import script from "./assistant-suggestion-pills.vue?vue&type=script&setup=true&lang=ts"
export * from "./assistant-suggestion-pills.vue?vue&type=script&setup=true&lang=ts"

import "./assistant-suggestion-pills.vue?vue&type=style&index=0&id=91a42968&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91a42968"]])

export default __exports__